var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1v4.5a.5.5 0 0 1-.5.5h-4.5m-10 9v-4.5A.5.5 0 0 1 1 10h4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.23 6A7.503 7.503 0 0 0 .77 6m0 4a7.503 7.503 0 0 0 14.46 0"
  }))));
};
export { SvgRefresh as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiPjxnIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiPjxwYXRoIGQ9Ik0xNS41IDF2NC41YS41LjUgMCAwIDEtLjUuNWgtNC41TS41IDE1di00LjVBLjUuNSAwIDAgMSAxIDEwaDQuNSIvPjxwYXRoIGQ9Ik0xNS4yMyA2QTcuNTAzIDcuNTAzIDAgMCAwIC43NyA2bTAgNGE3LjUwMyA3LjUwMyAwIDAgMCAxNC40NiAwIi8+PC9nPjwvc3ZnPg==";